import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Container, Typography, Alert } from "@mui/material";
import { linkifyPaths } from "./linkifyPaths";

/** Simple long-form content page (title + paragraphs). Interne paden in de
 *  tekst worden automatisch klikbaar. `draft` toont een "nog te reviewen"-
 *  banner voor pagina's die nog juridische controle nodig hebben. */
export default function InfoPage({ title, paras, draft, children }: { title: string; paras?: string[]; draft?: boolean; children?: React.ReactNode }) {
  const { t } = useTranslation();
  return (
    <Box sx={{ bgcolor: "background.default" }}>
      <Container maxWidth="md" sx={{ py: { xs: 5, sm: 8 } }}>
        <Typography variant="h1" sx={{ fontSize: { xs: "2.25rem", sm: "2.75rem" }, mb: 3 }}>{title}</Typography>
        {draft && <Alert severity="warning" sx={{ mb: 3 }}>{t("legal.draftNotice")}</Alert>}
        {paras?.map((p, i) => (
          <Typography key={i} sx={{ mb: 2, color: "text.secondary", lineHeight: 1.7 }}>{linkifyPaths(p)}</Typography>
        ))}
        {children}
      </Container>
    </Box>
  );
}
